import { useState, useEffect, useMemo } from 'react'
import axios, { AxiosError } from 'axios'
import appConfig from '../app-config'
import parsePhoneNumberFromString from 'libphonenumber-js'

declare global {
  type UserInput = {
   
    phoneNumber: string
    email: string
    ceremonies: { id: string; name: string }[]
    captchaToken: string | null
  }
}

export const useFetch = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const subscribeUrl = `${appConfig.baseUrl}/${appConfig.paths.apiPathCommencement}/notification/subscribe`
  const unsubscribeUrl = `${appConfig.baseUrl}/${appConfig.paths.apiPathCommencement}/notification/unsubscribe`

  const subscribeClient = useMemo(() => {
    return axios.create({
      baseURL: subscribeUrl,
      withCredentials: false
    })
  }, [subscribeUrl])

  const unsubscribeClient = useMemo(() => {
    return axios.create({
      baseURL: unsubscribeUrl,
      withCredentials: false
    })
  }, [unsubscribeUrl])

  const validateEmail =  (email: string) : boolean => {
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/
    if (!emailRegex.test(email)) {
      return false
    } else {
      return true
    }
  }

  const validatePhoneNumber =  (phone: string) : boolean => {
    const phoneNumber = parsePhoneNumberFromString(phone)
    if (!phoneNumber || !phoneNumber.isValid()) {
      return false;
    } else {
     return true;
    }
  }

  const subscribe = async (
    userData: UserInput | undefined
  ): Promise<number> => {
    if (loading) return 0

    if (!userData) return 0

    if (!userData.ceremonies) return 0

    console.log("DATA TO BE SENT: ", userData)
    const validEmail = validateEmail(userData.email)
    const validPhone = validatePhoneNumber(userData.phoneNumber)

    let uploadData: { email?: string; phone?: string; ceremonyId: string[] } = {
      email: validEmail ? userData.email : undefined,
      phone: validPhone ? userData.phoneNumber : undefined,
      ceremonyId: userData.ceremonies.map((ceremony) => {
        return ceremony.id
      })
    }
    console.log("Upload Data: ", uploadData)

    setLoading(true)

    let status = 0

    try {
      const response = await subscribeClient.post('', uploadData, {
        headers: {
          'Content-Type': 'application/json',
          'x-captcha-token': userData.captchaToken
        }
      })

      status = response?.status ?? 500
    } catch (error) {
      let axiosError = error as AxiosError

      status = axiosError?.response?.status ?? 500
    } finally {
      setLoading(false)
    }

    return status
  }

  const unsubscribe = async (
    userData: UserInput | undefined
  ): Promise<number> => {
    if (loading) return 0

    if (!userData) return 0

    if (!userData.ceremonies) return 0

    console.log("DATA TO BE SENT: ", userData)
    const validEmail = validateEmail(userData.email)
    const validPhone = validatePhoneNumber(userData.phoneNumber)

    let uploadData: { email?: string; phone?: string; ceremonyId: string[] } = {
      email: validEmail ? userData.email : undefined,
      phone: validPhone ? userData.phoneNumber : undefined,
      ceremonyId: userData.ceremonies.map((ceremony) => {
        return ceremony.id
      })
    }
    console.log("Upload Data: ", uploadData)

    setLoading(true)

    let status = 0

    try {
      const response = await unsubscribeClient.post('', uploadData, {
        headers: {
          'Content-Type': 'application/json',
          'x-captcha-token': userData.captchaToken
        }
      })

      status = response?.status ?? 500
    } catch (error) {
      let axiosError = error as AxiosError

      status = axiosError?.response?.status ?? 500
    } finally {
      setLoading(false)
    }

    return status
  }

  return { loading, subscribe, unsubscribe }
}

export const useInit = () => {
  const [data, setData] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<any>(null)
  const [status, setStatus] = useState<number>(0)

  const url = `${appConfig.baseUrl}/${appConfig.paths.apiPathCommencement}/init`

  const client = useMemo(() => {
    return axios.create({
      baseURL: url,
      withCredentials: false
    })
  }, [url])

  useEffect(() => {
    setLoading(true)
    client
      .get('', {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        setStatus(response?.status ?? 500)
        setLoading(false)
        setData(response.data)
      })
      .catch((error) => {
        setStatus(error.response?.status ?? 500)
        setLoading(false)
        setError(error)
      })
  }, [client])

  return { data, loading, error, status }
}
